import { SWRResponse } from "swr";
import { useV1List } from "~/hooks/useV1List";

// Largest `limit` a conversations API list endpoint accepts. Mirrors
// `conversations_types.constants.MAX_LIST_LIMIT`; a larger value gets a 422.
export const CONVERSATIONS_MAX_LIST_LIMIT = 100;

// SWR hook that returns every item from a conversations API list endpoint,
// walking pages at the API's list cap. The SWR key is the bare path, so
// `mutate(path)` revalidates the list.
export const useConversationsList = <T>(path: string | null): SWRResponse<T[]> =>
  useV1List<T>(path, { pageSize: CONVERSATIONS_MAX_LIST_LIMIT });
